import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AgentWhitelist";

const ChipsReport = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [casino, setCasino] = useState([]);
  const [fullCasino, setFullCasino] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // ⭐ Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const casinoData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(base_url + "/api/webapi/chipsData", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      if (response?.data?.success) {
        const data = response?.data?.result;
        setCasino(data);
        setFullCasino(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleFilter = () => {
    let filteredData = [...fullCasino];

    // filter by id, client id, client name
    if (search !== "") {
      filteredData = filteredData.filter(
        (row) =>
          row.id_user.toString().toLowerCase().includes(search.toLowerCase()) ||
          row.clientId.toString().toLowerCase().includes(search.toLowerCase()) ||
          row.client_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    // date filter
    if (startDate && endDate) {
      const start = new Date(startDate + "T00:00:00");
      const end = new Date(endDate + "T23:59:59");

      filteredData = filteredData.filter((row) => {
        const rowDate = new Date(row.time);
        return rowDate >= start && rowDate <= end;
      });
    }

    setCasino(filteredData);
  };

  useEffect(() => {
    casinoData();
  }, []);

  useEffect(() => {
    handleFilter();
    setCurrentPage(1); // reset page when filters change
  }, [search, startDate, endDate]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ⭐ Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = casino.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(casino.length / itemsPerPage);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

      <div
        className={`content-wrapper p-1 ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0" }}
      >
        <div className={`main-content ${isSidebarOpen ? "with-sidebar" : ""}`}>
          <div className="container-fluid py-4">
            <h3 className="text-dark mb-4">Chips Report</h3>

            {/* Search & Filter Section */}
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Enter ID or client id or client name"
                  className="form-control"
                  value={search}
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setCasino(fullCasino);
                    setSearch("");
                    setStartDate("");
                    setEndDate("");
                    setCurrentPage(1);
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* Table */}
            {casino.length === 0 ? (
              <div className="text-center py-5 text-muted">No Chips Data Found</div>
            ) : (
              <>
                <div className="table-responsive shadow-sm rounded bg-white p-3 w-100">
                  <table className="table-hover align-middle mb-0 w-100 overflow-auto">
                    <thead style={{ backgroundColor: "#182848", color: "white" }}>
                      <tr className="text-center border border-black">
                        <th>ID</th>
                        <th>Amount</th>
                        <th>My Old Balance</th>
                        <th>My New Balance</th>
                        <th>Client Id</th>
                        <th>Client Name</th>
                        <th>Client Role</th>
                        <th>Client Old Balance</th>
                        <th>Client New Balance</th>
                        <th>Type</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((row) => (
                        <tr key={row.id} className="text-center text-nowrap border border-dark">
                          <td>{row.id_user}</td>
                          <td>{row.amount}</td>
                          <td>{row.old_balance}</td>
                          <td>{row.new_balance}</td>
                          <td>{row.clientId}</td>
                          <td>{row.client_name}</td>
                          <td>{row.client_role}</td>
                          <td>{row.client_old_balance}</td>
                          <td>{row.client_new_balance}</td>
                          <td className={`badge fs-8 ${row.type === "online" ? "bg-success" : "bg-danger"}`}>
                            {row.type}
                          </td>
                          <td>{row.time.replace("T", " ").slice(0, 19)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* ⭐ Pagination Buttons */}
                <div className="d-flex justify-content-center mt-3 gap-2">
                  <button
                    className="btn btn-sm btn-dark"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Prev
                  </button>

                  {/* {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm ${
                        currentPage === index + 1 ? "btn-primary" : "btn-outline-primary"
                      }`}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))} */}

                  <button
                    className="btn btn-sm btn-dark"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChipsReport;
